const initialState = {
    enabled: false,
    rooms: [],
    users: [],
    isReadingChatRooms: false,
    isCreating: false
};

export default initialState;
